// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cab38e88","667":"a05f34a2"}[chunkId] + ".chunk.js";
};